import { render, staticRenderFns } from "./Feeders.vue?vue&type=template&id=785bf8cf"
import script from "./Feeders.vue?vue&type=script&lang=js"
export * from "./Feeders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports